import { Injectable, inject } from '@angular/core';
import { TradeInRequest } from '@app/sales/models/trade-in-product.model';
import { SetIsValidatingImeiAction } from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.actions';
import { TradeInSelectors } from '@app/sales/states/customer-product-trade-in/customer-product-trade-in.selectors';
import { FormSelectors } from '@app/sales/states/form/form.selectors';
import { Store } from '@ngxs/store';

@Injectable({
  providedIn: 'root',
})
export class TradeInHelperService {
  private store = inject(Store);

  public getPreviouslyValidatedImei(): string {
    return this.store.selectSnapshot(TradeInSelectors.previouslyValidatedImei);
  }

  public setIsValidatingImei(isValidating: boolean): void {
    this.store.dispatch(new SetIsValidatingImeiAction(isValidating));
  }

  public hasExistingError(): boolean {
    return !!this.store.selectSnapshot(TradeInSelectors.validateTradeInImeiError);
  }

  public createTradeInVoucherRequest(): TradeInRequest {
    const tradeInProduct = this.store.selectSnapshot(TradeInSelectors.tradeInProduct);
    const condition = this.store.selectSnapshot(FormSelectors.tradeInForm)?.model.condition;

    return {
      imei: tradeInProduct.specifications.imei,
      deviceVendor: tradeInProduct.specifications.deviceVendor,
      deviceModel: tradeInProduct.specifications.deviceModel,
      storageCapacity: tradeInProduct.specifications.selectedStorageCapacity,
      gradingQuestionAnswerPairs: tradeInProduct.gradingQuestions.map(question => {
        return {
          questionType: question.questionType,
          answer: condition[question.questionType],
        };
      }),
    } as TradeInRequest;
  }
}
